module.exports = __webpack_public_path__ + "img/symbol_1.59cd27a3.png";